import React, { useState, useRef, useCallback } from 'react';

/**
 * Card thumbnail with hover preview.
 * Uses position:fixed so the preview is never clipped by overflow containers.
 */
export default function CardThumbnail({ src, largeSrc, alt }) {
  const [show, setShow] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0, flipped: false });
  const wrapperRef = useRef(null);

  const handleMouseEnter = useCallback(() => {
    if (!wrapperRef.current) return;
    const rect = wrapperRef.current.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    // Preview is roughly 350px tall (250px wide, card aspect ~1.4)
    const previewHeight = 360;
    // If the thumbnail is in the bottom half and preview would overflow, flip above
    const flipped = rect.top + previewHeight > viewportHeight;

    setPos({
      left: rect.right + 12,
      top: flipped ? rect.bottom : rect.top,
      flipped,
    });
    setShow(true);
  }, []);

  const handleMouseLeave = useCallback(() => {
    setShow(false);
  }, []);

  return (
    <div
      className="card-thumbnail-wrapper"
      ref={wrapperRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <img
        src={src}
        alt={alt}
        className="card-thumbnail"
        loading="lazy"
      />
      {show && (
        <div
          className="card-image-preview card-image-preview--fixed"
          style={{
            top: pos.flipped ? 'auto' : pos.top,
            bottom: pos.flipped ? (window.innerHeight - pos.top) : 'auto',
            left: pos.left,
          }}
        >
          <img src={largeSrc || src} alt={alt} />
        </div>
      )}
    </div>
  );
}
